import isNumber from './is-number';
var isOdd = function (num) {
  return isNumber(num) && num % 2 !== 0;
};
export default isOdd;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/is-odd.js
// module id = 69
// module chunks = 0